import { render } from "./deposit.vue?vue&type=template&id=f9b60050&scoped=true"
import script from "./deposit.vue?vue&type=script&lang=js"
export * from "./deposit.vue?vue&type=script&lang=js"

import "./deposit.vue?vue&type=style&index=0&id=f9b60050&scoped=true&lang=css"
import "./deposit.vue?vue&type=style&index=1&id=f9b60050&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9b60050"]])

export default __exports__